let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1VyfL")).then(() => parcelRequire('2P8K7'));